// Ekstraøvelse: øverunde med komma og punktum (kun dansk, uden diktat).

import { round } from '../data/curriculum/generators';
import { getCumulativeUnlockedKeys } from './dictationUnits';
import { punctuationGenerator } from './punctuationPracticeGenerators';
import type { Trin, UserProfile } from '../types';

export const PUNCTUATION_PRACTICE_TRIN_ID = '__punctuation__';

export function isPunctuationPracticeEligible(user: UserProfile): boolean {
  return user.completedTrinIds.includes('niveau-4-trin-3');
}

export function buildPunctuationPracticeTrin(
  user: UserProfile,
): Trin | null {
  if (!isPunctuationPracticeEligible(user)) return null;

  const unlockedKeys = getCumulativeUnlockedKeys(user);
  const id = PUNCTUATION_PRACTICE_TRIN_ID;

  return {
    id,
    tierId: 'grundniveau',
    trinNumber: 0,
    title: 'Øverunde: Komma og punktum',
    description:
      'Korte sætninger og lister — nye ord hver gang du øver.',
    goal: 'Skriv tegnene som en naturlig del af ord og sætninger.',
    unlockedKeys,
    newKeys: [],
    rounds: [
      round({
        id: `${id}-r1`,
        title: 'Ord og punktum',
        purpose: 'Afslut korte ord med punktum og mellemrum.',
        mode: 'recall',
        generate: punctuationGenerator(user, 'period'),
      }),
      round({
        id: `${id}-r2`,
        title: 'Komma i sætning',
        purpose: 'Komma og fortsættelse i korte replikker.',
        mode: 'recall',
        generate: punctuationGenerator(user, 'dialog'),
      }),
      round({
        id: `${id}-r3`,
        title: 'Liste',
        purpose: 'Komma mellem ord — og før det sidste.',
        mode: 'recall',
        generate: punctuationGenerator(user, 'list'),
      }),
      round({
        id: `${id}-r4`,
        title: 'Mikroblanding',
        purpose: 'Punktum, komma og liste i én flow.',
        mode: 'recall',
        generate: punctuationGenerator(user, 'mix'),
      }),
    ],
  };
}
